var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToolbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "toolbox",
    transform: "translate(-237 -137)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_27",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 27",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(237 137)",
    fill: "#3a4557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "solid_toolbox",
    "data-name": "solid toolbox",
    d: "M15.706,37.707l-1.414-1.414A1,1,0,0,0,13.585,36H12V33.5A1.5,1.5,0,0,0,10.5,32h-5A1.5,1.5,0,0,0,4,33.5V36H2.414a1,1,0,0,0-.707.293L.293,37.707A1,1,0,0,0,0,38.414V41H4v-.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V41h4v-.5a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5V41h4V38.413A1,1,0,0,0,15.706,37.707ZM10,36H6V34h4Zm2,6.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V42H6v.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V42H0v3a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1V42H12Z",
    transform: "translate(241.25 109)",
    fill: "#fc1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbox);
export default __webpack_public_path__ + "static/media/toolbox.1f6fc4cbe8dcb7e441aa0dc318ede9e0.svg";
export { ForwardRef as ReactComponent };